<template>
  <div class="collapse-table">
    <table class="collapse-table__inner-table">
      <thead>
        <tr>
          <th class="collapse-table__header-cell">
            EXAMES
          </th>
          <th class="collapse-table__header-cell">
            MATERIAL
          </th>
          <th class="collapse-table__header-cell collapse-table__header-cell--button">
            Botão
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(exam, index) in exams"
          :key="index"
          class="collapse-table__row"
        >
          <td class="collapse-table__cell">
            {{ `${exam.examSent} - ${exam.nameExam}` }}
          </td>
          <td class="collapse-table__cell">
            {{ exam.material }}
          </td>
          <td class="collapse-table__cell">
            <DocumentUploadButton
              :is-document-delivered="allDocumentsDelivered(exam)"
              :exam-info="{
                osNumber: osAlvaro,
                id: exam.idExamOrder,
                name: exam.nameExam,
                documentExamsRequired: exam.documentExam
              }"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import DocumentUploadButton from '@/components/Documents/Laboratory/Modal/OpenModalButton'
import { uploadCompleted, eventBus } from '@/api/eventbus'

export default {
  name: 'CollapseTable',
  components: {
    DocumentUploadButton
  },
  props: {
    exams: {
      type: Array,
      required: true
    },
    osAlvaro: {
      required: true
    }
  },
  created() {
    let self = this
    eventBus.$on(uploadCompleted, function (os) {
      let examToUpdate = self.exams.find(exam => exam.idExamOrder === os.exam.id)
      if (examToUpdate) {
        examToUpdate.documentExam[os.docIndex].documentExamUpload = os.fileInfoUpdated
      }
      self.$emit('updateTableItemExams', self.exams)
    })
  },
  methods: {
    allDocumentsDelivered(exam) {
      return exam.documentExam.every(item => item.documentExamUpload !== null)
    }
  }
}
</script>

<style lang="scss" scoped>
  .collapse-table {
    background: #ebebeb;
    padding-bottom: 5px;
    border-bottom-left-radius: 7px;
    border-bottom-right-radius: 7px;
    position: relative;
    width: 100%;

    &__inner-table {
      width: 100%;
      border-spacing: 0;
      padding: 12px 30px;
    }

    &__header-cell {
      color: #999;
      font-size: 11px;
      font-weight: 400;
      text-transform: uppercase;
      letter-spacing: normal;
      padding-bottom: 10px;
      border-bottom: 2px solid #fff;

      &--button {
        width: 100px;
      }
    }

    &__cell {
      font-size: 14px;
      color: #797979;
      padding-top: 14px;
    }

    &__button {
    }
  }
</style>
